import styled from 'styled-components';
import { sizes } from 'style';
import { InfoText } from '../../styled';

export const Claimant = styled(InfoText)`
  @media ${sizes.desktop} {
    max-width: 100px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  @media ${sizes.largeDesktop} {
    max-width: 200px;
  }

  @media ${sizes.extraLargeDesktop} {
    max-width: 300px;
  }
`;
